//@flow
import React from 'react';
import ToggleButton from 'rc-switch';
import QuoteActions from '../../Actions/quote';
import ModalActions from '../../Actions/modal';
import Constants from '../../constants';
import TotalItem from '../../Cart/components/TotalItem.react';
import { isDiscountNotApplicable as isS2SNotApplicable, getShipDate } from '../../Utils/sub2save';
import UrlData from '../../Utils/url-data';

import type QuoteModel from '../../Stores/Quote/quoteModel';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';

type Props = {
  quote:QuoteModel,
  quoteTotals:QuoteTotalsModel,
  hasSubscription:boolean,
};

export default class SubscriptionSwitcher extends React.Component<Props> {
  switchQuoteType = (newValue:boolean) => {
    const quoteId = this.props.quote.getId();
    QuoteActions.updateQuote(quoteId, {
      subscribe: newValue,
    });
  }

  _openLearnMoreModal() {
    ModalActions.openModal(Constants.SUB2SAVE_LEARN_MORE_MODAL);
  }

  _getDescription() {
    const subtotal = this.props.quoteTotals.getGrandTotal();
    return `We'll conveniently ship you the items in your subscription on a monthly basis, charging your stored method of payment for each order. Your current subscription price is $${subtotal ? subtotal.toFixed(2) : 0} based on the items in your subscription, but this may change if you update the items for future orders. Prices are subject to change, and orders for less than $40 after discounts and membership savings will incur a $7.95 shipping fee. Your subscription will continue until you cancel.`;
  }

  _renderDescription() {
    return (
      <div className="sub-desc">
        <p>
          {this._getDescription()}&nbsp;
          <span className="link" onClick={this._openLearnMoreModal}>Learn more</span>
        </p>
        <span>
          <span className="bold">Ship date:</span>&nbsp;
          {getShipDate()} of {this.props.quote.getSSIntervalText()}
        </span>
        <div className="breadcrumbs">
          Cancel or modify at least 3 days before the ship date through your Account Settings.
        </div>
      </div>
    );
  }

  _renderSwitcher() {
    const discountDetails = this.props.quoteTotals ? this.props.quoteTotals.getSub2SaveDiscount() : undefined;
    const discount = discountDetails ? discountDetails.value : undefined;
    const strikeThrough = !discount ? " strike-through" : "";
    return (
      <TotalItem
        itemClassName={`row accent-1 bold sub-switcher-total-item${strikeThrough}`}
        itemName={this._renderItemName()}
        isNegative={true}
        total={discount}
        showIfNull={true}
      />
    );
  }

  _renderItemName() {
    return (
      <div className="sub-switcher-item-name">
        <ToggleButton
          checked={this.props.quote.isSubscription()}
          onChange={this.switchQuoteType}
        />
        <span className="sub-switcher-item-name-text">Autoship Monthly Subscription (save 10%)</span>
      </div>
    );
  }

  render() {
    const inFreeBoxPromo = UrlData.getPromoCode() === 'FREEBOX';
    // Don't show if there is enought store credit to not set a valid payment
    const isFree = this.props.quote.getPaymentMethod() === 'free';
    const s2sNotApplicable = isS2SNotApplicable(
      this.props.quote, this.props.quoteTotals);



    if (inFreeBoxPromo || this.props.hasSubscription ||
      s2sNotApplicable || isFree) return null;

    return (
      <div className="subscription-switch">
        <div className="sub-switcher-content group">
          {this._renderSwitcher()}
          {this._renderDescription()}
        </div>
      </div>
    );
  }
}
